import { StatusAction, StatusState } from './types';

export const wizardReducer = (state: StatusState, action: StatusAction): StatusState => {
  switch (action.type) {
    case 'UPDATE_STATUS':
      return { ...state, [action.stepIndex]: action.status };
    case 'RESET_STATUS':
      return { currentStep: 0 };
    case 'INITIALIZE_STATUS':
      return action.statuses;
    case 'SET_CURRENT_STEP':
      return { ...state, currentStep: action.stepIndex };
    default:
      return state;
  }
};
